import { IRSAKeyPair } from "../types/IWebCryptoRSA"
import { generateKeyPair } from "./generateKeyPair"
import { exportPrivateKey } from "./exportPrivateKey"
import { exportPublicKey } from "./exportPublicKey"

export async function getKeyPair(): Promise<IRSAKeyPair> {
  
  const keyPair = await generateKeyPair()
  
  return {
    privateKey: keyPair.privateKey,
    privateKeyBase64: await exportPrivateKey(keyPair),
    publicKey: keyPair.publicKey,
    publicKeyBase64: await exportPublicKey(keyPair),
  }
}
